import { ROLE_OPTIONS, LEAD_SOURCE_OPTIONS } from '../pages/Users/components/CreateUserModal/CreateUserModal.constants';
import { INDUSTRY_OPTIONS } from '../pages/UserDetail/components/EditUserModal.constants';
import { FISCAL_YEAR_END_OPTIONS } from '../constants/user';

/**
 * Get the display label for a role enum value
 * @param roleValue - The role enum value (e.g., 'CREDIT_MANAGER')
 * @returns The display label (e.g., 'Credit Manager') or the original value if not found
 */
export const getRoleDisplayValue = (roleValue: string | null | undefined): string => {
  if (!roleValue) return '';
  const role = ROLE_OPTIONS.find((opt) => opt.value === roleValue);
  return role?.label ?? roleValue;
};

/**
 * Get the display label for a lead source enum value
 * @param leadSourceValue - The lead source enum value (e.g., 'INBOUND_EMAIL')
 * @returns The display label (e.g., 'Inbound Email') or the original value if not found
 */
export const getLeadSourceDisplayValue = (leadSourceValue: string | null | undefined): string => {
  if (!leadSourceValue) return '';
  const leadSource = LEAD_SOURCE_OPTIONS.find((opt) => opt.value === leadSourceValue);
  return leadSource?.label ?? leadSourceValue;
};

/**
 * Get the display label for an industry value
 * @param industryValue - The industry value
 * @returns The display label or the original value if not found
 */
export const getIndustryDisplayValue = (industryValue: string | null | undefined): string => {
  if (!industryValue) return '';
  const industry = INDUSTRY_OPTIONS.find((opt) => opt.value === industryValue);
  return industry?.label ?? industryValue;
};

/**
 * Get the display label for a fiscal year end value
 * @param fiscalYearEndValue - The fiscal year end value (e.g., 'january')
 * @returns The display label (e.g., 'January') or the original value if not found
 */
export const getFiscalYearEndDisplayValue = (fiscalYearEndValue: string | null | undefined): string => {
  if (!fiscalYearEndValue) return '';
  const option = FISCAL_YEAR_END_OPTIONS.find((opt) => opt.value === fiscalYearEndValue.toLowerCase());
  return option?.label ?? fiscalYearEndValue;
};
